import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { map, Subject, takeUntil, filter } from 'rxjs';
import { CurrentStateService } from '../../../core/services/current-state.service';
import { ControlPoint } from '../../models/controlPoint';
import { SitesHttpService } from '../../services/http/sites-http.service';
import { Site } from '../../models/site';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { DropdownSitesComponent } from '../UI/dropdown-sites/dropdown-sites.component';
import { LocalStorageService } from '../../services/utilities/local-storage.service';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Coordinate } from 'ol/coordinate';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Router, NavigationEnd } from '@angular/router';
import { KeycloakService } from 'app/core/services/keycloak.service';



@Component({
  selector: 'app-nav-bar-top',
  imports: [
    CommonModule,
    TranslateModule,
    DropdownSitesComponent,
    AngularSvgIconModule
  ],
  templateUrl: './nav-bar-top.component.html',
  styleUrl: './nav-bar-top.component.scss'
})
export class NavBarTopComponent implements OnInit {

  @ViewChild('user') userDiv!: ElementRef;
  @ViewChild('language') languageDiv!: ElementRef;
  @ViewChild('dropdown') dropdownDiv!: ElementRef;
  protected selectedSite?: Site | undefined;
  protected selectedControlPoint?: ControlPoint;
  protected listeSites_filtred: Site[] = [];
  protected listeSites: Site[] = [];
  protected searchValue: string = '';
  protected controlPoints: ControlPoint[] = [];
  private unsubscribe$ = new Subject<void>();
  protected showContextMenu: boolean = false;
  protected menuPosition = { x: 0, y: 0 };
  protected pointClickedPosition: Coordinate | undefined;
  protected toggleSelectArray: boolean[] = [false, false];
  protected currentLang: string = 'en';

  valueWithSvgIcon: SafeHtml | undefined;

  userDivWidth: number | undefined;

  hideSitesSelection: boolean = false;

  constructor(
    private sitesHttpService: SitesHttpService,
    private currentStateService: CurrentStateService,
    private localStorageService: LocalStorageService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private router: Router,
    protected keycloakService: KeycloakService,
    protected cdr: ChangeDetectorRef
  ) {
    // is trigger when site is selected
    this.currentStateService.currentSite$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (site: Site | null) => {
          if (site) {
            this.selectedSite = site;
            this.currentStateService.setShowLoading(false);
            this.localStorageService.setItem('currentSiteID', site.siteId);
          }
        },
      });
  }

  ngOnInit() {
    this.init();
    this.currentLang = this.translate.currentLang;
    const currentUrl = this.router.url;
    this.hideSitesSelection = this.shouldHideSitesSelection(currentUrl);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.unsubscribe$)
    ).subscribe((event: NavigationEnd) => {
      this.hideSitesSelection = this.shouldHideSitesSelection(event.url);
      this.cdr.detectChanges();
    });
  }

  private shouldHideSitesSelection(url: string): boolean {
    return url.includes('/devices')
      || url.includes('/monitoring')
      || url.includes('/timeline');
  }

  ngAfterViewInit() {
    this.updateDivWidth(); // Initial width calculation after view initialization
  }

  private updateDivWidth() {
    const userDivWidth = this.userDiv.nativeElement.offsetWidth;
    this.userDivWidth = userDivWidth;
    
    // this.renderer.setStyle(this.dropdownDiv.nativeElement, 'width', userDivWidth + 'px');

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private init() {
    const sitesActiveObs = this.sitesHttpService
      .getSitesAcitve()
      .pipe(
        map((sites) =>
          sites.map((site) => ({
            ...site,
            groupByNomRegion: site.region!.nom,
          }))
        ),
        map((sites) =>
          sites.sort((a, b) => {
            if (a.groupByNomRegion < b.groupByNomRegion) return -1;
            if (a.groupByNomRegion === b.groupByNomRegion) {
              return a.nom > b.nom ? 1 : -1;
            }
            return 1;
          })
        ),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (sites) => {
          this.listeSites_filtred = [...sites];
          this.listeSites = [...sites];
          this.localStorageService.setItem('allSites', this.listeSites);
        },
        error: (err) => {
          console.error('Error fetching sites:', err);
        },
      });
  }


  protected definirSiteEnCours(site: Site) {
    this.localStorageService.setItem('currentSiteID', site.siteId);
    this.currentStateService.setCurrentSite(site);
    this.selectedSite = site;
  }

  protected hideDropdown(index: number) {
    this.toggleSelectArray[index] = false;
  }

  changeLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('lastLang', lang);
    this.hideDropdown(1);
  }

  navigateToSettings(): void {
    this.router.navigate(['/settings']);
    this.hideDropdown(0);
  }

}
